import { createRouter, createWebHistory } from 'vue-router'
import Form from '../components/Form.vue'  
import SuccessPage from '../components/SuccessPage.vue'
import ErrorPage from '../components/ErrorPage.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Form',
      component: Form
    },
    {
      path: '/support/success',
      name: 'Success',
      component: SuccessPage
    },
    {
      path: '/error',  
      name: 'Error',
      component: ErrorPage,
      props: route => ({ 
        code: route.query.code,
        message: route.query.message 
      })
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

export default router